import { get } from 'lodash';
import { EMPTY_STRING, NUMBER_ZERO } from '@mitchell/react.component.ux';
import { getPhotoCaptureEvaluationDocId } from "../../../domain/photoCapture";
import { getQuestionnaireEvaluationDocId } from "../../../domain/questionnaireEvaluation";
import { getVehicleConfigurationAttributesByType, VehicleConfigurationAttributesType } from "../../../domain/vehicleConfigurationAttributes";
export const getGPCEvaluationDocId = (state) => getPhotoCaptureEvaluationDocId(state) || getQuestionnaireEvaluationDocId(state).toString();
export const getVehicleAttributeInfo = (state) => {
    const { pinAttributes, nadaAttributes, redbookAttributes } = {
        pinAttributes: getVehicleConfigurationAttributesByType(state, VehicleConfigurationAttributesType.PIN_ATTRIBUTES),
        nadaAttributes: getVehicleConfigurationAttributesByType(state, VehicleConfigurationAttributesType.NADA_ATTRIBUTES),
        redbookAttributes: getVehicleConfigurationAttributesByType(state, VehicleConfigurationAttributesType.REDBOOK_ATTRIBUTES)
    };
    return {
        pinVid: get(pinAttributes, '[0].pinVid', NUMBER_ZERO),
        nadaVid: get(nadaAttributes, '[0].nadaVid', NUMBER_ZERO),
        redbookControlNumber: get(redbookAttributes, '[0].controlNumber', EMPTY_STRING)
    };
};
//# sourceMappingURL=guidedPhotoCaptureUtility.js.map